import { DatePicker } from '@mui/x-date-pickers';
import React, { useState, useEffect } from 'react';

const TimePicker = ({
    label,
    id,
    onFieldChange,
    initialTime,
    validate,
    isDateString = true,
}) => {
    console.log('received', initialTime);

    const [selectedDate, setSelectedDate] = useState(
        isDateString
            ? new Date(initialTime.slice(0, initialTime.length - 5))
            : initialTime
    );

    useEffect(() => {
        if (isDateString) {
            setSelectedDate(
                new Date(initialTime.slice(0, initialTime.length - 5))
            );
        } else {
            setSelectedDate(initialTime);
        }
    }, [initialTime]);

    return (
        <DatePicker
            margin="outlined"
            id={id}
            label={label}
            onChange={(date, dateStr) => {
                console.log('value', date, dateStr);
                onFieldChange(date, dateStr);
            }}
            value={selectedDate}
            KeyboardButtonProps={{
                'aria-label': 'change time',
            }}
        />
    );
};

export default TimePicker;
